@if (collectionLoading) {
<div class="loading">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>
} @else{ @if (collection) {
<div class="container">
  <div class="location">
    <a routerLink="/search" aria-label="All Products">Shop All</a>
    <span> › </span>
    <a>{{collection.name}}</a>
  </div>
  <h1 showleft>{{collection.name}}</h1>
  @if (collection.description) {
  <p showleft [showDelay]="100">{{collection.description}}</p>
  }

  <div class="content">
    <app-product-filters-panel [(ngModel)]="filters" (ngModelChange)="onFiltersChanged()"
      [disabled]="productsLoading"></app-product-filters-panel>
    <div class="collection">
      @if (collection.cover) {
      <div class="img" showleft [showDelay]="200">
        <img [ngSrc]="collection.cover | fileurl" fill [alt]="collection.name + ' collection cover'" />
      </div>
      }
      <div class="action">
        <app-product-filters-button [(ngModel)]="filters" (ngModelChange)="onFiltersChanged()"
          [disabled]="productsLoading"></app-product-filters-button>
        <app-product-order-by-select [(ngModel)]="orderBy"
          (ngModelChange)="onOrderByChanged()"></app-product-order-by-select>
      </div>
      @if (productsLoading) {
      <div class="loading"><mat-spinner [diameter]="40"></mat-spinner></div>
      }@else if ( products.length>0) {

      <app-product-list [products]="products"></app-product-list>

      <mat-paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]" [hidePageSize]="true"
        [pageIndex]="page-1" (page)="onPageChanged($event)" aria-label="Select page">
      </mat-paginator>
      }@else{
      <nz-empty></nz-empty>
      }
    </div>
  </div>
  <app-recently-viewed-product-list></app-recently-viewed-product-list>
</div>
} }